<template>
  <div class="rating">
    <div class="star" v-if="calificacion == 0">
      <i class="fa fa-star-o"></i>
    </div>
    <div class="star" v-if="calificacion == 0">
      <i class="fa fa-star-o"></i>
    </div>
    <div class="star" v-if="calificacion == 0">
      <i class="fa fa-star-o"></i>
    </div>
    <div class="star" v-if="calificacion == 0">
      <i class="fa fa-star-o"></i>
    </div>
    <div class="star" v-if="calificacion == 0">
      <i class="fa fa-star-o"></i>
    </div>
    <div class="star" v-if="calificacion > 0">
      <i :class="{
            'fa': true,
            'fa-star-o': calificacion == 0 ? true : false, 
            'fa-star-half-o': calificacion >= 0 & calificacion < 1 ? true : false,
            'fa-star': calificacion >= 1 ? true : false
          }"></i>
    </div>
    <div class="star" v-if="calificacion > 1">
      <i :class="{
            'fa': true,
            'fa-star-o': calificacion < 1 ? true : false, 
            'fa-star-half': calificacion >= 1.0 & calificacion < 2.0 ? true : false,
            'fa-star': calificacion >= 2 ? true : false,
          }"></i>
    </div>
    <div class="star" v-if="calificacion > 2">
      <i :class="{  
            'fa': true,
            'fa-star-o': calificacion < 2 ? true : false, 
            'fa-star-half': calificacion >= 2.0 & calificacion < 3.0 ? true : false,
            'fa-star': calificacion >= 3 ? true : false,
          }"></i>
    </div>
    <div class="star" v-if="calificacion > 3">
      <i :class="{
            'fa': true,
            'fa-star-o': calificacion < 3 ? true : false, 
            'fa-star-half': calificacion >= 3.0 & calificacion < 4.0 ? true : false,
            'fa-star': calificacion >= 4 ? true : false,
          }"></i>
    </div>
    <div class="star" v-if="calificacion > 4">
      <i :class="{
            'fa': true,
            'fa-star-o': calificacion < 4 ? true : false, 
            'fa-star-half': calificacion >= 4.0 & calificacion < 5.0 ? true : false,
            'fa-star': calificacion >= 5 ? true : false,
          }"></i>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TableSlotRating',
  props: {
    calificacion: {
      type: Number,
      default: 0
    }
  },
  created() {
  },  
  methods: {
  },
}
</script>

<style>
  .rating .star {
    margin-right: 5px;
  }
</style>